import { ApplicationRef, 
         ComponentFactoryResolver, 
         ComponentRef, 
         Injectable,
         Injector, 
         ViewContainerRef, 
         EmbeddedViewRef, 
         Type }                     from '@angular/core';
import { NavigationService } from 'source/app/objects/navigation/navigation-service';
import { NavigationItem } from 'source/app/objects/navigation/navigation-item';
import { Dictionary } from 'source/app/objects/dictionary';

@Injectable()
export class AppNavigation extends NavigationService {
    constructor( ) {
        super();
        this.Items = new Dictionary<NavigationItem>();
        this.Items.add("Welcome", new NavigationItem('Welcome', 'welcome', '/home/welcome') );
        this.Items.add("Bar", new NavigationItem('Bar', 'bar', '/home/bar') );
        this.Items.add("Breadcrumb", new NavigationItem('Breadcrumb', 'breadcrumb', '/home/breadcrumb'));
        this.Items.add("Busy Indicators", new NavigationItem('Busy Indicators', 'busy-indicators', '/home/busy-indicators') );
        this.Items.add("Buttons", new NavigationItem('Buttons', 'buttons', '/home/buttons') );
        this.Items.add("Cards", new NavigationItem('Cards', 'cards', '/home/cards') );
        this.Items.add("Charts", new NavigationItem('Charts', 'charts', '/home/charts') );
        this.Items.add("CheckBox", new NavigationItem('Check Box', 'check-box', '/home/check-box') );
        this.Items.add("CheckBoxComboBox", new NavigationItem('Check Box Combo Box', 'check-box-combo-box', '/home/check-box-combo-box') );
        this.Items.add("CheckBoxListBox", new NavigationItem('Check Box List Box', 'check-box-list-box', '/home/check-box-list-box') );
        this.Items.add("ComboBox", new NavigationItem('Combo Box', 'combo-box', '/home/combo-box') );
        this.Items.add("ContextMenu", new NavigationItem('Context Menu', 'context-menu', '/home/context-menu') );
        this.Items.add("DevPlayground", new NavigationItem('Dev Playground', 'dev-playground', '/home/dev-playground') );
        this.Items.add("Expander", new NavigationItem('Expander', 'expander', '/home/expander') );
        this.Items.add("FormControls", new NavigationItem('Form Controls', 'form-controls', '/home/form-controls') );
        this.Items.add("Graph", new NavigationItem('Graph', 'graph', '/home/graph'));
        this.Items.add("Grid", new NavigationItem('Grid', 'grid', '/home/grid'));
        this.Items.add("Icons", new NavigationItem('Icons', 'icons', '/home/icons'));
        this.Items.add("Layout", new NavigationItem('Layout', 'layout', '/home/layout'));
        this.Items.add("ListBox", new NavigationItem('List Box', 'list-box', '/home/list-box') );
        this.Items.add("Menu", new NavigationItem('Menu', 'menu', '/home/menu') );
        this.Items.add("Modals", new NavigationItem('Modals', 'modals', '/home/modals') );
        this.Items.add("Panels", new NavigationItem('Panels', 'panels', '/home/panels') );        
        this.Items.add("Primitives", new NavigationItem('Primitives', 'primitives', '/home/primitives') );
        this.Items.add("RadioButton", new NavigationItem('Radio Button', 'radio-button', '/home/radio-button'));
        this.Items.add("Sidebar", new NavigationItem('Sidebar', 'sidebar', '/home/sidebar'));
        this.Items.add("Sidenav", new NavigationItem('Sidenav', 'sidenav', '/home/sidenav'));
        this.Items.add("Slider", new NavigationItem('Slider', 'slider', '/home/slider'));
        this.Items.add("Switch", new NavigationItem('Switch', 'switch', '/home/switch'));
        this.Items.add("Tabs", new NavigationItem('Tabs', 'tabs', '/home/tabs') );
        this.Items.add("TextBox", new NavigationItem('Text Box', 'text-box', '/home/text-box') );
        this.Items.add("Toast", new NavigationItem('Toast', 'toast', '/home/toast'));
        this.Items.add("Toolbar", new NavigationItem('Toolbar', 'toolbar', '/home/toolbar'));
        this.Items.add("Tooltip", new NavigationItem('Tooltip', 'tooltip', '/home/tool-tip'));
        this.Items.add("Tree", new NavigationItem('Tree', 'tree', '/home/tree') );
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/app-navigation.ts